/* eslint-disable max-len */
import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Helmet} from 'react-helmet';
import styled from 'styled-components';

import api, {graphqlQueryBuild} from '../services/api';
import {notWebMediaQuery, PageBodyWrapper} from '../styles';

import VideosGrid from '../components/VideosGrid';
import Loader from '../components/Loader';
import {debugCNitoUrl} from '../helpers';
import VideosHeader from '../components/Cartoonito/VideosHeader';

const CartoonitoHome = props => {
    const {t} = useTranslation();
    const history = useHistory();
    const {user, recommendation} = useSelector(state => state);
    const idp = user && user.idp;

    props = {
        ...props,
        ...useSelector(state => {
            return {...state.show, ...state.user};
        }),
    };

    const [readyState, setReadyState] = useState(false);
    const [vods, setVods] = useState(undefined);
    const [sentPageview, setSentPageview] = useState(false);

    useEffect(() => {
        if (!sentPageview) {
            setSentPageview(true);

            window.turner_metadata.trackAction.push({
                type: 'pageview',
                data: {
                    pageName: `${window.location.hostname}/home`,
                    section: 'Homepage',
                    subsection: 'nvs',
                    contenttype: 'Homepage',
                    contenttitle: 'Homepage',
                    presentationtemplate: 'desktop',
                    platform: 'web',
                    domain: `web|${window.location.hostname}`,
                    region: 'latam',
                    country:
                        user && user.countryIsoCode && user.countryName
                            ? `${user.countryIsoCode.toLowerCase()}|${
                                  user.countryName
                              }`
                            : 'not loaded',
                    brand: 'cartoonito',
                    pageviewevent: 1,
                    authstate:
                        user && user.jwtToken
                            ? 'authenticated'
                            : 'unauthenticated',
                    mvpd: idp || 'idp not loaded',
                },
            });
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setReadyState(false);

        if (user.catalogTenant || !user.jwtToken) {
            handleLoadHomeRows();
        }

        // eslint-disable-next-line
    }, [user.catalogTenant, user.jwtToken]);

    useEffect(() => {
        if (vods !== undefined && !readyState) {
            setReadyState(true);
        }

        // eslint-disable-next-line
    }, [vods]);

    const handleLoadHomeRows = async () => {
        const watchedVideos = Object.values(recommendation.videos)
            .filter(video => video.showId)
            .slice(0, 5)
            .reduce((acc, curr) => [...acc, curr.id], []);

        let query = graphqlQueryBuild(
            'homeRows',
            `
                title
                vods {
                    id
                    title
                    image
                    duration
                    episode
                    season
                    description
                    externalId

                    show {
                        title
                    }
                }`,
            `ids: [${watchedVideos}]`,
        );

        let response = await api
            .get('', {
                params: {
                    query,
                },
            })
            .then(res => res)
            .catch(err => {
                // eslint-disable-next-line no-console
                console.log(err);
                history.push(`/error${debugCNitoUrl()}`);
            });

        if (response.data && response.data.data?.homeRows) {
            setVods(response.data.data.homeRows[1].vods);
        } else {
            history.push(`/error${debugCNitoUrl()}`);
        }
    };

    const handleClickEp = (episode_id, item) => {
        history.push(`/play/${episode_id}${debugCNitoUrl()}`);
    };

    return (
        <>
            <Helmet>
                <title>{t('cartoonito.videos.metaTitle')}</title>
                <meta
                    name="description"
                    content={t('cartoonito.videos.metaDescription')}
                />
            </Helmet>

            <Container>
                <div>
                    {!readyState ? (
                        <Loader />
                    ) : (
                        <>
                            <VideosHeader />
                            <ContentHolder>
                                <Background />
                                <VideoContent>
                                    <VideosGrid
                                        items={vods}
                                        onClickItem={handleClickEp}
                                        hidePlayButton
                                        cnito
                                    />
                                </VideoContent>
                            </ContentHolder>
                        </>
                    )}
                </div>
            </Container>
        </>
    );
};

const Container = styled(PageBodyWrapper)`
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-height: calc(100vh - 392px);
    width: 100%;
    box-sizing: border-box;
    background-color: #f6d703;
    padding-top: 100px;

    & > div {
        flex: 1;
        width: 100%;

        margin-left: auto;
        margin-right: auto;
        display: flex;
        flex-direction: column;
    }
`;

const VideoContent = styled.div`
    width: 100%;
    display: flex;
    //background-color: #3cc265;
    padding-bottom: 80px;
    align-items: center;
    flex-direction: column;
    //margin-top: -3.5vw;

    ${notWebMediaQuery} {
        padding-bottom: 32px;
    }
`;

const ContentHolder = styled.div`
    position: relative;
`;

const Background = styled.div`
    position: absolute;
    top: 9vw;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #3cc265;
`;

export default CartoonitoHome;
